import { createSlice } from '@reduxjs/toolkit';
import { getPatientNameOverridesApi } from '../../../rtk-apis/reports/getPatientNameOverrides';

const initialState = { status: '', result: {} as Record<string, string>, msg: '', loading: false };

const getPatientNameOverridesSlice = createSlice({
  name: 'getPatientNameOverrides',
  initialState,
  reducers: {
    clearState: state => { state.status = ''; state.result = {}; state.msg = ''; state.loading = false; },
  },
  extraReducers: builder => {
    builder
      .addCase(getPatientNameOverridesApi.pending, state => { state.loading = true; })
      .addCase(getPatientNameOverridesApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload?.result || {};
      })
      .addCase(getPatientNameOverridesApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = action?.payload as string;
      });
  },
});

export const { clearState } = getPatientNameOverridesSlice.actions;
export default getPatientNameOverridesSlice.reducer;
